import axios from 'axios';
import { getAuthHeader } from "./auth";


//const API = axios.create({
//  baseURL: 'http://localhost:8080/api',
//});
const baseURL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/api/archive'
    : '/api/archive';     // proxy /api → Spring


export const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(config => {
  config.headers = {
    ...config.headers,
    ...getAuthHeader()
  };
  return config;
});

// Функции для каждого эндпоинта
export const fetchProducts     = () => api.get('/products');
export const fetchProductById  = id => api.get(`/products/${id}`);
export const createProduct     = data => api.post('/products', data);

export const fetchDetails      = () => api.get('/details');
export const fetchDetailById   = id => api.get(`/details/${id}`);
export const createDetail      = data => api.post('/details', data);
export const fetchDetailTypes = () => api.get('/detailTypes');
export const fetchManufacturers = () => api.get('/manufacturers');
export const fetchStamps = () => api.get('/stamps');
export const fetchProductChildren = (id) => api.get(`/products/${id}/children`);
export const createManufacturer = (data) => api.post('/manufacturers', data);
export const submitChangeRequest = (payload) =>
  api.post('/change-requests', payload);
export const fetchManufacturerById = (id) => api.get(`/manufacturers/${id}`);



export const uploadPhoto       = file => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/photos', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const annotatePhoto     = (photoId, { productId, detailId }) =>
  api.post(`/photos/${photoId}/annotate`, null, {
    params: { productId, detailId }
  });

//export const getDetails = () => {
//  return API.get('/details');
//};
//
//export const getDetailById = (id) => {
//  return API.get('/details/${id}');
//};